import {
    getSessionStorageItemJson,
    SailsVvlStorage,
} from '@vfde-sails/storage';
import {
    NSF_STORAGE_CURIOSITY_FLOW,
    SAILS_PARAM_CUSTOMER,
    SAILS_VVL_STORAGE,
} from '@vfde-sails/constants';
import { NsfStorage } from '../../../interface';

const getIsXsellEligible = (): boolean => getIsXsellEligibleFromSailsStorage() || getIsXsellEligibleFromNsfStorage();

export default getIsXsellEligible;

const getIsXsellEligibleFromSailsStorage = (): boolean => {
    const storage = getSessionStorageItemJson<SailsVvlStorage>(SAILS_VVL_STORAGE);

    if (!storage) {
        return false;
    }

    return storage[SAILS_PARAM_CUSTOMER]?.isRedplusEligible;
};

const getIsXsellEligibleFromNsfStorage = (): boolean => {
    const storage = getSessionStorageItemJson<NsfStorage>(NSF_STORAGE_CURIOSITY_FLOW);

    if (!storage || !storage.customer) {
        return false;
    }

    const customer = JSON.parse(storage.customer);

    return customer.isXsellEligible;
};
